<template>
  <ProjectHeader :color="project ? project.color : null">
    <div class="left-part spacex-16">
      <SidebarOpener />
      <router-link :to="{ name: 'summary', params: { id: tenderInfo && tenderInfo.project_id } }">
        <BackIcon class="icon-14px white-icon-btn" />
      </router-link>
      <div v-if="tenderInfo && tenderInfo.name" class="flex-row flex-centering spacex-16">
        <div class="flex-row flex-centering spacex-4">
          <div class="text text-bold text-mr8 no-wrap text-header tender-ellipsis-name">
            {{ tenderInfo.name }}
          </div>
          <v-tooltip
            v-if="tenderInfo.name && tenderInfo.description"
            bottom
            max-width="345"
            transition="scroll-y-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <InfoIcon class="pointer no-outline white-icon-btn" v-bind="attrs" v-on="on" />
            </template>
            <div>
              {{ tenderInfo.description }}
            </div>
          </v-tooltip>
        </div>
        <Badge v-if="tenderInfo.offers_count" color="white">
          <span class="text text-black fs-14 fw-5">
            {{ $tc('offer', tenderInfo.offers_with_submitted_version_count) }}
          </span>
        </Badge>
        <div v-if="prettyDeadline" class="text text-white no-wrap fs-14 fw-5">
          {{ $t('Deadline') }}: {{ prettyDeadline }}
        </div>
      </div>
      <v-skeleton-loader v-else type="heading" width="400" />
    </div>

    <div v-if="tenderInfo" class="right-part">
      <div class="flex-row spacex-16">
        <div class="flex-centering pointer white-icon-btn" @click="editTender(tenderInfo.id)">
          <EditIcon class="icon-20px p-3" />
          <span class="ml-4 no-wrap fw-6 unselectable">
            {{ $t('Edit tender') }}
          </span>
        </div>
      </div>
    </div>
  </ProjectHeader>
</template>

<script>
  import EditIcon from '@/assets/icons/edit.svg';
  import SidebarOpener from '@/containers/top-menu/SidebarOpener';
  import BackIcon from '@/assets/icons/arrow-left-black.svg';
  import InfoIcon from '@/assets/icons/info.svg';
  import { VTooltip, VSkeletonLoader } from 'vuetify/lib';
  import prettyDates from '@/utils/formatting/pretty-date';
  import Badge from '@/components/ui/Badge';
  import editTender from '@/utils/mixins/edit-tender';
  import { mapActions, mapState } from 'vuex';
  import ProjectHeader from '@/components/header/ProjectHeader';
  import tender from '@/store/tender';
  import { addModule } from '@/store';

  export default {
    name: 'TenderHeader',
    components: {
      Badge,
      SidebarOpener,
      BackIcon,
      EditIcon,
      InfoIcon,
      VTooltip,
      VSkeletonLoader,
      ProjectHeader,
    },
    meta() {
      if (this.project)
        return {
          title: `${this.project.name} — Fixtender`,
        };
    },
    created() {
      addModule('tender', tender);
    },
    mixins: [editTender],
    props: {
      project: Object,
    },
    computed: {
      ...mapState({
        tenderInfo: (state) => {
          return state.tender.tenderInfo;
        },
        selectedVersion: (state) => state.incomingTender.selectedVersion,
      }),
      prettyDeadline() {
        if (this.tenderInfo.offers_deadline_date) {
          return prettyDates({
            start: this.tenderInfo.offers_deadline_date,
            end: this.tenderInfo.offers_deadline_date,
          });
        } else {
          return null;
        }
      },
    },
    methods: {
      ...mapActions({
        openModal: 'modal/openModal',
      }),
    },
  };
</script>
